import script from "./eventCategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./eventCategories.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__